import { FEATURES } from '@constants/Text'
import * as dashboard from "./store"

export const PERMISSION = FEATURES.BI_V2

export function dashboardModule({store}) {
    store.registerModule('dashboard', {...dashboard, namespaced: true})
}